import { useAppActions } from "../../overmind";
import Portal from "./Portal";
import { Slide } from "react-awesome-reveal";
import { useState, useEffect } from "react";
import Bg_menu from "../../assets/img/bg_menu.jpg";

import BuyCoinsForm from "../forms/BuyCoinsForm";
import WithdrawCoinsForm from "../forms/WithdrawCoinsForm";
import WalletConnect from "../WalletConnect";
import { getCurrentWallet, getChipsBalance } from "../../core/web3";


const Menu = ({ wallet, setWallet }) => {
  const { toggleMenu } = useAppActions();
  const [currentForm, setCurrentForm] = useState("");
  const [address, setAddress] = useState("");
  const [balance, setBalance] = useState(0);
  const [updateBalance, setUpdateBalance] = useState(0);

  useEffect(async () => {
    // setTimeout(async () => {
      let res = await getCurrentWallet();
      if (res.success) {
        let chipsAmount1 = await getChipsBalance();
        let chipsAmount = window.web3.utils.fromWei("" + chipsAmount1, 'ether');
        setAddress(res.account);
        setBalance(chipsAmount);
      } else {
        setAddress("");
        setBalance(0);
      }
    // }, 1000);
  }, [updateBalance]);

  return (
    <Portal>
      <div className="fixed inset-0 z-800 flex w-screen flex-col justify-center align-middle">
        <button
          tabIndex={-1}
          onClick={() => toggleMenu(false)}
          className="absolute inset-0 h-full w-full cursor-default bg-black bg-opacity-70"
        />

        <Slide
          direction="right"
          duration={300}
          triggerOnce
          className="my-auto ml-auto h-full w-full overflow-y-auto bg-gray-900 py-2 px-3 520:py-3 980:w-2/3 sm:px-6 md:w-2/5"
        >
          <div className="py-4">
            <div className="flex justify-center align-middle">
              <button
                onClick={() => toggleMenu(false)}
                className="p-3 rounded-full bg-red-500 hover:bg-red-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            {wallet ? (
              <div className="mt-8">
                <div
                  onClick={() => setWallet(!wallet)}
                  className="border-2 border-amber-500 rounded-xl font-secondary bg-amber-500 bg-opacity-10 px-3 py-4 text-white"
                >
                  <div className="text-amber-500 text-sm uppercase">
                    address
                  </div>

                  <div className="mt-2">{address}</div>

                  <div className="mt-5 text-amber-500 text-sm uppercase">
                    balance
                  </div>

                  <div className="mt-2 font-semibold text-xl tracking-wide">
                    {Number(balance).toFixed(3).toLocaleString()}
                  </div>
                </div>

                {!currentForm && (
                  <>
                    <button
                      onClick={() => setCurrentForm("buyCoins")}
                      className="primary-btn from-green-500 to-green-700 hover:from-green-700 mt-8"
                    >
                      Buy coins
                    </button>

                    <button
                      onClick={() => setCurrentForm("withdrawCoins")}
                      className="primary-btn from-gray-500 to-gray-700 mt-5 hover:from-gray-700"
                    >
                      Withdraw coins
                    </button>
                  </>
                )}

                <>
                  <div className="py-4"></div>
                  {currentForm === "buyCoins" && (
                    <BuyCoinsForm balanceCallback={() => setUpdateBalance(!updateBalance)} goBack={() => setCurrentForm("")} />
                  )}

                  {currentForm === "withdrawCoins" && (
                    <WithdrawCoinsForm balanceCallback={() => setUpdateBalance(!updateBalance)} goBack={() => setCurrentForm("")} />
                  )}
                </>
              </div>
            ) : (
              <div
                style={{ marginTop: "20px", cursor: "pointer" }}
                className="mt-20px flex justify-center"
              >
                <div className="flex flex-col md:flex-row md:max-w-xl rounded-lg bg-white shadow-lg">
                  <WalletConnect wallet={wallet} setWallet={setWallet} />
                </div>
              </div>
            )}
          </div>
        </Slide>
      </div>
    </Portal>
  );
};

export default Menu;
